import stories from "../../assets/home/desktop/beautiful-stories.jpg";
import designed from "../../assets/home/desktop/designed-for-everyone.jpg";

import storiesMedium from "../../assets/home/mobile/beautiful-stories.jpg";
import designedMedium from "../../assets/home/mobile/designed-for-everyone.jpg";

export const HomepageItems = [
	{
		cName: "hero white reverse",
		title: "BEAUTIFUL STORIES EVERY TIME",
		paragraph:
			"We provide design templates to ensure your stories look terrific. Easily add photos, text, embed maps and media from other networks. Then share your story with everyone.",
		button: "VIEW THE STORIES",
		src: stories,
		srcSet: storiesMedium,
	},
	{
		cName: "hero white",
		title: "DESIGNED FOR EVERYONE",
		paragraph:
			"Photosnap can help you create stories that resonate with your audience. Our tool is designed for photographers of all levels, brands, businesses you name it.",
		button: "VIEW THE STORIES",
		src: designed,
		srcSet: designedMedium,
	},
];
